import { FC } from "react"
import { Button, Layout } from "../components"
import logo from "../assets/logo.svg";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

const CustomButton = styled(Button)`
  width: calc(100% - 21px);
  margin-top: 32px;
`;

const Logo = styled.img`
  @media(max-width: 470px) {
    width: 128px;
  }
`;

const DefaultPage: FC<{title: string}> = observer(({title}) => {

  const navigate = useNavigate();

  return <Layout title={title}>
    <Logo src={logo} alt="Chiorio logotype" width={180} height={180} />
    <CustomButton onClick={() => navigate("master")}>Оформить заказ</CustomButton>
  </Layout>
});

export default DefaultPage;